import { useEffect, useState } from 'react';
import { api } from '../api';

export default function DownloadPage() {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ category_code: 'CATALOG', download_name: '', preview_image_path: '' });
  const [file, setFile] = useState(null);
  const [editId, setEditId] = useState(null);

  const load = () => api.downloads.list().then(setItems).catch((error) => alert(error.message));
  useEffect(() => {
    api.downloads.categories().then(setCategories).catch((error) => alert(error.message));
    load();
  }, []);

  const submit = (event) => {
    event.preventDefault();
    if (!editId && !file) {
      alert('파일을 선택하세요.');
      return;
    }
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => formData.append(key, value || ''));
    if (file) formData.append('file', file);
    api.downloads.save(editId, formData)
      .then(() => { setForm({ category_code: 'CATALOG', download_name: '', preview_image_path: '' }); setFile(null); setEditId(null); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>다운로드</h2>
      <form onSubmit={submit}>
        <select value={form.category_code} onChange={(e) => setForm({ ...form, category_code: e.target.value })}>
          {categories.map((item) => <option key={item.category_code} value={item.category_code}>{item.category_name}</option>)}
        </select>
        <input placeholder="이름" value={form.download_name} onChange={(e) => setForm({ ...form, download_name: e.target.value })} />
        <input placeholder="미리보기 이미지 파일명 (public)" value={form.preview_image_path || ''} onChange={(e) => setForm({ ...form, preview_image_path: e.target.value })} />
        <input type="file" onChange={(e) => setFile(e.target.files[0])} />
        <div className="row">
          <button type="submit">{editId ? '수정' : '추가'}</button>
          <button type="button" className="ghost" onClick={() => { setEditId(null); setFile(null); }}>취소</button>
        </div>
      </form>
      <table>
        <thead><tr><th>분류</th><th>이름</th><th>파일</th><th></th></tr></thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.download_id}>
              <td>{item.category_name}</td>
              <td>{item.download_name}</td>
              <td>{item.file_name}</td>
              <td className="row">
                <button type="button" onClick={() => { setEditId(item.download_id); setForm(item); }}>수정</button>
                <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.downloads.remove(item.download_id).then(load)}>삭제</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
